export default __webpack_public_path__ + "static/media/logo.7c1b054f.png";